// extracted by mini-css-extract-plugin
module.exports = {"CommentAuthor":"CommentAuthor_CommentAuthor__yGuOw"};